import history from '../../util/history'

const toRoomEditView = roomId => {
  history.push(`/setting/${roomId}/info`)

  return true
}

export default toRoomEditView
